/* Native BYOB gift safety only; Rebuy keeps cart rendering and checkout behavior. */
(function (root) {
  'use strict';
  function inspect(cart,versions) {
    if(!cart || !Array.isArray(cart.items) || cart.items.length>100)return {known:false,unsafe:[],native:false};
    var unsafe=[],known=true,native=false,keys=new Set();
    cart.items.forEach(function(it){
      if(!it || typeof it!=='object'){known=false;return;}
      var p=it.properties || {};
      if(p._malezia_source!=='byob-native' && p._malezia_bundle_id!=='byob')return;
      // An ordinary native paid line omits the gift flag. Explicit malformed flags are unknown.
      var mixed=['_source','_widget_id','_attribution','_r_added_bundle_session_id'].some(function(k){return Object.prototype.hasOwnProperty.call(p,k);});
      if(mixed){native=true;known=false;return;}
      if(!Object.prototype.hasOwnProperty.call(p,'_malezia_gift'))return;
      native=true;
      if(![true,'true'].includes(p._malezia_gift)){known=false;return;}
      if(p._malezia_source!=='byob-native' || p._malezia_bundle_id!=='byob' || typeof p._malezia_bundle_session!=='string' || !p._malezia_bundle_session.length || p._malezia_bundle_session.length>128 ||
        !versions.includes(p._malezia_rules_version) || typeof it.key!=='string' || !/^\d+:[a-zA-Z0-9_-]+$/.test(it.key) || keys.has(it.key) ||
        !Number.isSafeInteger(it.quantity) || it.quantity<1 || !Number.isSafeInteger(it.final_line_price) || it.final_line_price<0 ||
        !Array.isArray(it.line_level_discount_allocations)){known=false;return;}
      keys.add(it.key);
      var free=it.final_line_price===0 && !it.selling_plan_allocation && it.line_level_discount_allocations.some(function(a){
        return a && Number.isSafeInteger(a.amount) && a.amount>0 && a.discount_application && a.discount_application.title==='Free gift 🎁';
      });
      if(!free)unsafe.push(it.key);
    });
    return {known:known,unsafe:unsafe,native:native};
  }
  root.MaleziaByobGiftPolicy={inspect:inspect};
  if(!root.document)return;
  var config;
  try {config=JSON.parse(document.getElementById('malezia-byob-gift-guard-config').textContent);}catch(_){return;}
  if(config.enabled!==true || config.schemaVersion!==1 || config.cartProvider!=='rebuy' || config.globalNative!==false ||
    !['preview','live'].includes(config.source) || !Array.isArray(config.acceptedRulesVersions) || !config.acceptedRulesVersions.length ||
    config.acceptedRulesVersions.length>4 || !config.acceptedRulesVersions.every(function(v){return typeof v==='string' && /^[a-zA-Z0-9._-]{1,32}$/.test(v);}))return;
  var theme=root.Shopify && root.Shopify.theme;
  // URL/editor flags do not override the observed Shopify theme role.
  var source=theme && theme.role==='unpublished'?'preview':theme && theme.role==='main'?'live':'unknown';
  if(source!==config.source || String(theme && theme.id)!==config.themeId)return;
  var inFlight=null,last=null,revision=0,review=false,checkoutBusy=false,replay=null,ambiguous=false,events=[];
  function record(reason){events.push({ts:Date.now(),reason:reason});if(events.length>40)events.shift();}
  function snapshot(c){return JSON.stringify({total:c.total_price,items:c.items.map(function(it){return [it.key,it.quantity,it.final_line_price,it.selling_plan_allocation,it.line_level_discount_allocations];})});}
  function notify(message){
    var n=document.getElementById('malezia-byob-gift-notice');
    if(!n){n=document.createElement('div');n.id='malezia-byob-gift-notice';n.setAttribute('role','status');
      n.style.cssText='position:fixed;bottom:16px;left:16px;right:16px;z-index:2147483646;padding:16px;background:#fff;color:#153d33;border:1px solid #153d33;font:16px/1.4 sans-serif;';
      var text=document.createElement('span');n.appendChild(text);var close=document.createElement('button');close.type='button';close.textContent='Dismiss';
      close.style.cssText='margin-left:12px';close.onclick=function(){n.remove();};n.appendChild(close);document.body.appendChild(n);}
    n.firstChild.textContent=message;
  }
  async function json(path,body){
    var options={method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(5000)};
    if(body){options.headers={'Content-Type':'application/json'};options.body=JSON.stringify(body);}
    var r=await fetch(path,options);if(!r.ok)throw new Error('cart-request-failed');return r.json();
  }
  function refreshRebuy(){try {if(root.Rebuy && root.Rebuy.Cart)root.Rebuy.Cart.fetchShopifyCart(function(){});}catch(_){record('cart-ui-refresh-failed');}}
  function refresh(){
    if(inFlight)return inFlight;
    inFlight=(async function(){
      var removed=0;
      for(var pass=0;pass<6;pass++){
        var before=revision,c=await json('/cart.js');
        if(before!==revision)continue;
        var state=inspect(c,config.acceptedRulesVersions);
        if(!state.known)throw new Error('native-gift-context-unassessable');
        if(!state.unsafe.length){last=c;if(removed)refreshRebuy();return c;}
        if(ambiguous)throw new Error('gift-removal-ambiguous-reload-required');
        if(removed>=3)throw new Error('gift-removal-bound');
        var key=state.unsafe[0];
        try {await json('/cart/change.js',{id:key,quantity:0});}
        catch(_){
          // An ambiguous POST is never replayed. A fresh read may establish another tab already removed it.
          ambiguous=true;record('gift-removal-ambiguous');
          var fresh=await json('/cart.js'),f=inspect(fresh,config.acceptedRulesVersions);
          if(f.known && !f.unsafe.length){last=fresh;review=true;refreshRebuy();return fresh;}
          throw new Error('gift-removal-unverified');
        }
        removed++;revision++;review=true;record('native-gift-removed');
        notify('A promotional gift is no longer free and was removed. Please review your updated cart before checkout.');
      }
      throw new Error('cart-keeps-changing');
    })().finally(function(){inFlight=null;});
    return inFlight;
  }
  function observe(){revision++;refresh().catch(function(){record('cart-verification-held');});}
  async function admission(){
    var before=last && snapshot(last),seenRevision=revision;
    try {
      var c=await refresh();
      if(review || before!==snapshot(c) || seenRevision!==revision){review=false;throw new Error('review-updated-cart');}
      // A second cache-free read closes an ordinary in-flight edit window; this is not a server transaction lock.
      var verify=await json('/cart.js'),state=inspect(verify,config.acceptedRulesVersions);
      if(!state.known || state.unsafe.length || seenRevision!==revision || snapshot(c)!==snapshot(verify))throw new Error('cart-changed');
      last=verify;return true;
    }catch(_){record('checkout-held');notify('Please review your updated cart. If it is still updating, wait and try checkout again.');return false;}
  }
  function checkoutUrl(href){try {var u=new URL(href,location.href);return u.origin===location.origin && /\/checkout(?:\/|$)/.test(u.pathname);}catch(_){return false;}}
  function target(event){
    var el=event.target && event.target.closest && event.target.closest('button,a,input');
    if(event.type==='submit'){
      var form=event.target,submitter=event.submitter;
      if(form && (checkoutUrl(form.action) || submitter && submitter.name==='checkout'))return {form:form,element:submitter};
      return null;
    }
    if(el && (el.matches('.rebuy-cart__checkout-button,[name="checkout"]') || el.tagName==='A' && checkoutUrl(el.href)))return {element:el};
    return null;
  }
  function intercept(event){
    var t=target(event);if(!t)return;
    if(replay && ((t.form || t.element)===replay || t.form && t.form===replay.form))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(checkoutBusy)return;checkoutBusy=true;
    admission().then(function(ok){
      if(!ok)return;
      // Invoke the exact original control once, retaining Rebuy pre-purchase/analytics/checkout behavior.
      replay=t.form || t.element;
      try {if(t.form)t.form.requestSubmit(t.element || undefined);else if(t.element.isConnected)t.element.click();}
      finally {replay=null;}
    }).finally(function(){checkoutBusy=false;});
  }
  root.addEventListener('click',intercept,true);root.addEventListener('submit',intercept,true);
  ['rebuy:cart.ready','rebuy:cart.change','rebuy:cart.add','byob:added','cart:refresh'].forEach(function(e){document.addEventListener(e,observe);});
  root.addEventListener('focus',observe);
  root.MaleziaByobGiftGuard={active:true,events:events,refresh:refresh,admission:admission,acceptedRulesVersions:config.acceptedRulesVersions.slice()};
  refresh().catch(function(){record('cart-verification-held');});
})(typeof window==='undefined'?globalThis:window);
